import { render, staticRenderFns } from "./classBox.vue?vue&type=template&id=2f486533&scoped=true"
import script from "./classBox.vue?vue&type=script&lang=js"
export * from "./classBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f486533",
  null
  
)

export default component.exports